import { render, staticRenderFns } from "./SearchPrevious.vue?vue&type=template&id=1bec4671"
import script from "./SearchPrevious.vue?vue&type=script&lang=js"
export * from "./SearchPrevious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports